// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { CustomAppState } from "@bg/App/Store/Reducers";
import { fontConfig } from "@bg/XDL/PreStyle/typography";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import translate from "@insite/client-framework/Translate";
import Hidden, { HiddenProps } from "@insite/mobius/Hidden";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import getColor from "@insite/mobius/utilities/getColor";
import React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: CustomAppState) => ({
    homePageUrl: getPageLinkByPageType(state, "HomePage")?.url,
})

type Props = HiddenProps & ReturnType<typeof mapStateToProps>;

interface ContinueShoppingLinkStyles {
    link?: LinkPresentationProps;
}

export const continueShoppingLinkStyles: ContinueShoppingLinkStyles = {
    link: {
        typographyProps:{
            weight: fontConfig.weight.semiBold,
            lineHeight: fontConfig.lineHeight.singleLineSmall,
            css: css`
                color: ${getColor("secondary.main")};
                opacity: 0.7;
            `,
        }
    }
}

const styles = continueShoppingLinkStyles;
const ContinueShoppingLink: React.FC<Props> = ({ homePageUrl, ...otherProps }) => {
    return (
        <Hidden {...otherProps} data-test-selector="ContinueShoppingHidden">
            <Link
                href={homePageUrl}
                {...styles.link}
                aria-label={translate("Go to Home Page")}
                data-test-selector="ContinueShoppingLink"
            >
                {translate("Continue Shopping")}
            </Link>
        </Hidden>
    );
};

export default connect(mapStateToProps)(ContinueShoppingLink);
